import { Component, DestroyRef, inject } from '@angular/core';
import { ProgressLoaderComponent } from '../../../../components/loaders/progress-loader/progress-loader.component';
import {
  InstitutionTabelComponent
} from '../../../../components/card/institution/institution-tabel/institution-tabel.component';
import { PaginationComponent } from '../../../../components/pagination/pagination.component';
import { Institution, InstitutionQueryParams } from '../../../../interfaces/responses/institution.interface';
import { InstitutionService } from '../../../../services/institution/institution.service';
import { PaginationInterface } from '../../../../interfaces/responses/pagination.interface';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ProductDetailsStore } from '../product-details.store';

@Component({
  selector: 'app-institutions',
  imports: [
    ProgressLoaderComponent,
    InstitutionTabelComponent,
    PaginationComponent,
  ],
  templateUrl: './institutions.component.html',
  styleUrl: './institutions.component.scss',
})
export class InstitutionsComponent {
  isInstitutionLoading: boolean = true;
  institutionService = inject(InstitutionService);
  private route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  protected productDetailsStore = inject(ProductDetailsStore);

  institutions: Institution[] = [];
  allInstitutions!: PaginationInterface<Institution[]>;

  institutionId!: string;
  institutionQueryParams: InstitutionQueryParams = {
    paginate: true,
    perPage: 10,
    productId: '',
  }

  constructor() {
    toObservable(this.productDetailsStore.productId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((id) => {
        if (!id) return;
        this.institutionQueryParams.productId = id;
        this.getInstitutionOfAProduct();
      });
  }

  ngOnInit(): void {
  }

  getInstitutionOfAProduct() {
    this.isInstitutionLoading = true;
    this.institutionService.getPaginatedInstitutions(this.institutionQueryParams).subscribe({
      next: (response) => {
        // ...existing code (map response to this.institutions if needed)...
        this.institutions = response.data
        this.allInstitutions = response;
        this.isInstitutionLoading = false;
      },
      error: (error) => {
        console.error('Error fetching institution of product:', error);
        this.isInstitutionLoading = false;
      },
    });
  }


  onPageChange(page: number): void {
    this.institutionQueryParams.page = page
    this.getInstitutionOfAProduct();
  }
}
